export const CHECKOUT_URL = 'https://postoperative-en.impultienda.ar/checkout/';

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/bYmG3EYdUkHWXdcCDQD7Ha/MOCKUP_POSTOPERATIVE-EN.png';

export const AUTHOR_IMAGE =
  'https://cdn.magicpatterns.com/uploads/xaMaZtWfXu7ean3ucaUfDb/Rachel_Bennett_-_NURSING.png';
